import { applyOverrides } from '../../shared';
import type { LocaleOverrides } from '../../types';
import { BaseLandlordConfig } from '../landlord';
import { buyerCard, buyersAgentCard, commissionDetailsCard } from './cards';

export const BaseDualConfig = applyOverrides(BaseLandlordConfig, {
  sections: {
    propertyInfo: {
      cards: {
        commissionDetailsCard,
      },
    },
    buyerSideContacts: {
      cards: {
        buyerCard,
        buyersAgentCard: () => buyersAgentCard,
      },
    },
  },
});

export type DualLocaleOverrides = LocaleOverrides<typeof BaseDualConfig>;
